import React, { useCallback } from 'react';
import { Textarea } from '@gafe/common-ui';

import { useOrderContext, useOrderDispatch } from '@/components/modals/SubmitOrder/helpers';

import styles from './DeliveryDetails.module.scss';

export const DeliveryDetails = () => {
  const state = useOrderContext();
  const dispatch = useOrderDispatch();

  const handleChange = useCallback(
    (value: string) => {
      dispatch({
        type: 'UPDATE_ORDER',
        payload: {
          deliveryInstruction: value,
        },
      });
    },
    [dispatch],
  );

  return (
    <div className={styles.delivery_instructions_wrapper}>
      <div className={styles.delivery_instructions_title}>
        Additional Delivery Instructions <span>(optional)</span>
      </div>
      <Textarea
        name="deliveryInstructions"
        onChange={handleChange}
        placeholder="Please include any site or contact information important for delivery or other instructions."
        testId="textarea-input"
        value={state.order.deliveryInstruction ?? ''}
      />
    </div>
  );
};
